import React, { useState, useRef } from 'react';
import { CalculatorInstance } from './CalculatorInstance';
import { CalculationResult } from '../../types';
import { FileText, TrendingUp } from 'lucide-react';

interface CalculatorManagerProps {
  onShowTrend: () => void;
  onResultsUpdate: (results: CalculationResult[]) => void;
}

export function CalculatorManager({ onShowTrend, onResultsUpdate }: CalculatorManagerProps) {
  const [calculators, setCalculators] = useState<number[]>([0]);
  const [results, setResults] = useState<CalculationResult[]>([]);
  const resultsRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleAddCalculator = () => {
    const newIndex = calculators.length;
    setCalculators(prev => [...prev, newIndex]);
    
    // Scroll to new calculator after render
    setTimeout(() => {
      resultsRefs.current[newIndex]?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const handleDeleteCalculator = (index: number) => {
    setCalculators(prev => prev.filter((_, i) => i !== index));
    setResults(prev => prev.filter((_, i) => i !== index));
    onResultsUpdate(results.filter((_, i) => i !== index));
  };

  const handleCalculate = (result: CalculationResult, index: number) => {
    const newResults = [...results];
    newResults[index] = result;
    setResults(newResults);
    onResultsUpdate(newResults);
  };

  return (
    <div className="space-y-6">
      {calculators.map((_, index) => (
        <CalculatorInstance
          key={index}
          index={index}
          onDelete={index > 0 ? () => handleDeleteCalculator(index) : undefined}
          onCalculate={(result) => handleCalculate(result, index)}
          resultsRef={{ current: resultsRefs.current[index] }}
        />
      ))}

      {results.length > 0 && (
        <div className="flex justify-center gap-4">
          <button
            onClick={handleAddCalculator}
            className="btn-primary flex items-center gap-2"
          >
            <FileText size={20} />
            Add Role Calculation
          </button>
          <button
            onClick={onShowTrend}
            className="btn-primary flex items-center gap-2"
          >
            <TrendingUp size={20} />
            Show Trend
          </button>
        </div>
      )}
    </div>
  );
}